'use client'

import { Box, ButtonBase, Typography } from '@mui/material'

import ErrorLogo from './error-logo'

import styles from './error-card.module.scss'

export const ErrorCard = ({ children }: React.PropsWithChildren) => {
  return (
    <Box borderRadius={1} className={styles.root}>
      <ErrorLogo className={styles.icon} />

      <Typography variant="h3" component="p">
        Looks like something broke...
      </Typography>

      <p>
        Try{' '}
        <ButtonBase
          onClick={() => window.location.reload()}
          className={styles.buttonLink}
        >
          refreshing your page
        </ButtonBase>
        .
      </p>

      {children}
    </Box>
  )
}
